import {createFileRoute, redirect} from '@tanstack/react-router';

import {Route as RouteEnum, SettingsSearchParams} from '~utils/routeUtil';

export const Route = createFileRoute('/settings/')({
  validateSearch: SettingsSearchParams.validate,
  beforeLoad: async () => {
    // Redirect to default settings page (general)
    throw redirect({
      to: RouteEnum.settingsGeneral as any,
    });
  },
});
